import React, { useEffect, useState } from "react";
import MealSearch from "./MealSearch";
import RecipeList from "./RecipeList";
import "../styles/RecipeList.css";
import "../styles/RecipeCard.css";
import { useIngredients } from "../context/IngredientsProvider";

const RecipeView: React.FC = () => {
  const { selectedIngredients, setSelectedIngredients } = useIngredients();
  const [recipes, setRecipes] = useState<any[]>(
    JSON.parse(sessionStorage.getItem("recipes") || "[]")
  );
  const [aiRecipe, setAiRecipe] = useState<string | null>(
    sessionStorage.getItem("aiRecipe") || null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (recipes.length === 0 && !aiRecipe) {
      sessionStorage.removeItem("recipes");
      sessionStorage.removeItem("aiRecipe");
    }
  }, [recipes, aiRecipe]);

  useEffect(() => {
    sessionStorage.setItem("recipes", JSON.stringify(recipes));
  }, [recipes]);

  useEffect(() => {
    if (aiRecipe) {
      sessionStorage.setItem("aiRecipe", aiRecipe);
    } else {
      sessionStorage.removeItem("aiRecipe");
    }
  }, [aiRecipe]);

  return (
    <div className="recipe-view">
      <MealSearch
        onSearch={(foundRecipes) => {
          setAiRecipe(null);
          setRecipes(foundRecipes);
        }}
        onAiSearch={setAiRecipe}
        selectedIngredients={selectedIngredients.map((ing) => ing.value)}
        setSelectedIngredients={(newIngredients) => {
          if (!Array.isArray(newIngredients)) return;
          setSelectedIngredients(
            newIngredients.map((ingredient) => ({
              value: ingredient,
              label: ingredient,
            }))
          );
        }}
        setLoadingAiRecipe={setIsLoading}
      />

      {recipes.length === 0 && !aiRecipe && (
        <div className="recipe-placeholder-logo">
          <img
            src="/images/fiksukaappi_logo.png"
            alt="FiksuKaappi logo"
            className="recipe-logo"
          />
        </div>
      )}

      {aiRecipe ? (
        <RecipeList recipes={[]} aiRecipe={aiRecipe} isLoading={isLoading} />
      ) : recipes.length > 0 ? (
        <RecipeList recipes={recipes} aiRecipe={null} isLoading={false} />
      ) : null}
    </div>
  );
};

export default RecipeView;
